<template>
  <div class="people-info">
    <b-container>
      <b-row class="people">
        <b-col md="6" sm="12">
          <a class="link text-decoration-none" :href="person.linkedin_Url" target="_blank" ><img class="image card1" v-lazy="require(`@/assets/img/${person.image}`)" /></a>
        </b-col>
        <b-col md="5" sm="12" class="my-auto">
          <div class=" information blue_color">
            <p class="name">{{person.name}}</p>
            <p class=" position">{{person.position}}</p>
            <p class="description">{{person.description}}</p>
            <b-row id="person-logo" class="logo-section">
              <b-col   v-for="(img, index) in person.logos" :key="index">
                <Smalllogocard :image="img.logo" :visitUrl="img.visit_url"/>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Smalllogocard from "../common/small-logo-card";
export default {
  name: "Peopleinfo",
  props: ["person"],
  components: { Smalllogocard },
  data() {
    return {
      // img:"singapore.jpg"
    };
  }
};
</script>
<style scoped>
.card1 {
  border-radius: 20px;
  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4); */
    width: 100%;
    height: 100%;
}
.card2{
  border-radius: 10px;
  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4); */
    width: 100%;
    height: 67%;
}

.founder-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--mainBlueColor);
}
.founder-designation {
  font-size: 17px;
  font-weight: 600;
  color: var(--mainBlueColor);
}
.logos {
  width: 100px;
  height: 100px;
  display: inline-block;
  box-shadow: 1px 1px 6px #d0d0d0;
}
.blue_color {
  color: var(--mainBlueColor);
}
.people{
  margin-top:2rem;
}
.position{
  font-size:1.2rem;
  font-weight:500;
}
.description{
  margin-top:2rem;
  margin-bottom:2rem;
  text-align:justify;
  font-size:1rem;
  word-spacing: -2px;
}

.information{
  padding-left:3rem;
  text-align:left;
}

.name{
  font-weight:600;
  font-size:1.7rem;
  margin-bottom:0;
}
@media (min-width: 768px) and (max-width: 1024px){
  .information{
    margin-top:2rem;
    padding-left:0;
  }
  .position{
    font-size:1.1rem;
    text-align:left;
  }
  .description{
    font-size:0.9rem;
  }
  .name{
    font-size:1.2rem;
    text-align:left;
  }

}
@media (min-width: 481px) and (max-width: 767px) {
.information{
    margin-top:2rem;
    padding-left:0;
  }
  .position{
    font-size:1.1rem;
    text-align:center;
  }
  .description{
    font-size:0.75rem;
  }
  .name{
    font-size:1.2rem;
    text-align:center;
  }

}


@media (max-width: 480px) {
  .information{
    margin-top:2rem;
    padding-left:0;
  }
  .position{
    font-size:1.1rem;
    text-align:center;
  }
  .description{
    font-size:0.75rem;
  }
  .name{
    font-size:1.2rem;
    text-align:center;
  }
  

}
</style>